import { useEffect, useState } from 'react';
import {
  Controller as RHFController,
  ControllerProps,
  FieldPath,
  FieldValues,
  useFormContext,
} from 'react-hook-form';

import { useOptional } from '../hooks';

/**
 * Fixed version of `react-hook-form`'s `Controller` component
 * that rerenders when the form control changes.
 * @see {@link RHFController}
 * @inheritdoc {@link RHFController}
 */
export function Controller<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: ControllerProps<TFieldValues, TName>) {
  const form = useOptional(useFormContext<TFieldValues>);
  const [key, setKey] = useState(0);
  const control = props.control || form?.control;
  useEffect(() => setKey((c) => c + 1), [control]);

  return <RHFController {...props} key={key} />;
}
